<div class="container-fluid m-0 p-0" *ngIf="!showLoader">
    <form [formGroup]="updateTeacherCourse" (change)="updateTeacherCourseChange()" (submit)="updateTeacherCourseSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"TEACHER_COURSE_UPDATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/academics/teacher-courses"
                    *ngIf="!updating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "TEACHER" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="teacher">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of teachers" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.teacherNameAr : res.teacherNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.teacher.touched && updateTeacherCourse.controls.teacher.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
<!--                             <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "TEACHER_TYPE" | translate | titlecase }}/{{ "SECONDARY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="teacherType">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="TEMPORARY">{{"TEMPORARY" | translate | titlecase }}</option>
                                    <option value="PERMANENT">{{"PERMANENT" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.teacherType.touched && updateTeacherCourse.controls.teacherType.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "COURSE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="course">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of courses" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.subjectNameAr : res.subjectNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.course.touched && updateTeacherCourse.controls.course.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "PRIMARY" | translate | titlecase }}/{{ "SECONDARY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="courseType">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="PRIMARY">{{"PRIMARY" | translate | titlecase }}</option>
                                    <option value="SECONDARY">{{"SECONDARY" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.courseType.touched && updateTeacherCourse.controls.courseType.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"REMARKS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.remarks.touched && updateTeacherCourse.controls.remarks.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateTeacherCourse.controls.active.touched && updateTeacherCourse.controls.active.invalid && updateTeacherCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>